/* eslint-disable no-underscore-dangle */
import { EquipmentCheck } from "app/modules/main/types/equipmentCheck"

// ENV TYPE
export const PROD = "production"
export const STAGING = "staging"
export const DEV = "development"

export const DEFAULT_PHONE_NUMBER = "+33 1 76 41 14 88"

export const PREVIEW_CLIENT_ID = "web-preview"

export const SEB_QUITTING_LINK = "https://testwe.eu/quitSeb"

export const DURATION_TIMEOUT_AXIOS = 100000

export const CACHED_PROCTORNB_KEY = "CACHED_PROCTORNB_KEY"

export const EMPTY_STRING = ""

export const TRAINING = "training"
export const TRAINING_SPREADSHEET = "trainingSpreadSheet.xslx"
export const TRAINING_MP3 = "trainingMp3.mp3"
export const TRAINING_PDF = "trainingPdf.pdf"
export const TRAINING_IMG1 = "trainingImg1.png"
export const TRAINING_IMG2 = "trainingImg2.png"
export const TRAINING_IMG3 = "trainingImg3.png"
export const TRAINING_IMG4 = "trainingImg4.png"
export const TRAINING_IMG5 = "trainingImg5.png"
export const TRAINING_IMG6 = "trainingImg6.png"
export const TRAINING_IMG7 = "trainingImg7.png"
export const TRAINING_IMG8 = "trainingImg8.png"
export const TRAINING_IMG9 = "trainingImg9.png"

export const PROCTOR_END_EXAM = "PROCTOR_END_EXAM"

export const DEFAULT_LANG = "defaultlang"
export const TIMEZONE = "timezone"

export const CLEAR_REDUCERS = "CLEAR_REDUCERS"

export const PADDING_SIDES = 40

// INPUT
export const INPUT_HEIGHT = 50
export const INPUT_PADDING = 10

// HEIGHT
export const HEIGHT_HEADER = 80

// WIDTH EXAM TAKING CONTENT
export const LARGE_WIDTH = "84.666667%"
export const MEDIUM_WIDTH = "68%"

// WIDTH BOOTSTRAP
export const WIDTH_0_5 = "7%"
export const WIDTH_1 = "8.333333%"
export const WIDTH_1_2 = "10%"
export const WIDTH_1_5 = "14.285715%"
export const WIDTH_2 = "16.666667%"
export const WIDTH_2_5 = "20%"
export const WIDTH_3 = "25%"
export const WIDTH_4 = "33.333333%"
export const WIDTH_5 = "41.666667%"
export const WIDTH_6 = "50%"
export const WIDTH_7 = "58.333333%"
export const WIDTH_8 = "66.666667%"
export const WIDTH_9 = "75%"
export const WIDTH_10 = "83.333333%"
export const WIDTH_11 = "91.666667%"
export const WIDTH_12 = "100%"

// FONTSIZES
export const FONTSIZE_8 = 8
export const FONTSIZE_9 = 9
export const FONTSIZE_10 = 10
export const FONTSIZE_11 = 11
export const FONTSIZE_12 = 12
export const FONTSIZE_13 = 13
export const FONTSIZE_14 = 14
export const FONTSIZE_16 = 16
export const FONTSIZE_18 = 18
export const FONTSIZE_21 = 21
export const FONTSIZE_24 = 24
export const FONTSIZE_36 = 36
export const FONTSIZE_40 = 40
export const FONTSIZE_55 = 55
export const FONTSIZE_65 = 65

// FONTFAMILY
export const FONT_GILROY_REGULAR = "Gilroy-Regular"
export const FONT_GILROY_ITALIC = "Gilroy-Italic"
export const FONT_GILROY_LIGHT = "Gilroy-Light"
export const FONT_GILROY_MEDIUM = "Gilroy-Medium"
export const FONT_GILROY_BOLD = "Gilroy-Bold"
export const FONT_GILROY_SEMI_BOLD = "Gilroy-SemiBold"
export const FONT_GILROY_EXTRA_BOLD = "Gilroy-ExtraBold"
export const FONT_TUNGSTENCONDENSED_LIGHT = "TungstenCondensed-Light"
export const FONT_TUNGSTENCONDENSED_MEDIUM = "TungstenCondensed-Medium"
export const FONT_TUNGSTENCONDENSED_SEMIBOLD = "TungstenCondensed-SemiBold"
export const FONT_TUNGSTENCONDENSED_BOLD = "TungstenCondensed-Bold"

export const MULTIPLE_CHOICE_QUESTION = "multiple_choice_question"
export const SINGLE_CHOICE_QUESTION = "single_choice_question"
export const SHORT_QUESTION = "short_question"
export const TEXT_BLANKS_QUESTION = "text_blanks_question"
export const TEXT_DROPDOWN_QUESTION = "text_dropdown_question"
export const GRID_SINGLE_CHOICE_QUESTION = "grid_single_choice_question"
export const GRID_MULTIPLE_CHOICE_QUESTION = "grid_multiple_choice_question"
export const AUDIO_QUESTION = "audio_question"
export const SPREADSHEET_QUESTION = "spreadsheet_question"
export const DISSERTATION_QUESTION = "dissertation_question"

export const PARTINDEX_TYPE_QUESTION = "question"
export const PARTINDEX_TYPE_EXERCISE = "exercise"

export const NOTIFICATION_END_POINT = HEIGHT_HEADER
export const DURATION_NOTIFICATION = 5000
export const DURATION_ANIMATION_NOTIFICATION = 180

// FILES FOLDER
export const ATTACHED_FILES = "attachedFiles"
export const PROCTOR_FILES = "proctor"
export const EXAM_FILES = "files"
export const EXPORT_FILES = "export"

// MIMETYPE
export {
  MIME_JPEG,
  MIME_JPG,
  MIME_PNG,
  MIME_GIF,
  MIME_IMAGE,
  MIME_PDF,
  MIME_CSV,
  MIME_MS,
  MIME_SHEET,
  MIME_SPREADSHEET,
  MIME_MP4,
  MIME_AVI,
  MIME_WEBM,
  MIME_QUICKTIME,
  MIME_3GP,
  MIME_VIDEO,
  MIME_OCTETSTREAM,
  MIME_MP3,
  MIME_MPEG,
  MIME_MP4A,
  MIME_WEBA,
  MIME_WAV,
  MIME_M4A,
  MIME_AUDIO,
  MIME_DEFAULT,
} from "../../core/constants/mimeTypes"

// PROCTORING
export const WIDTH_PROCTORING_CAMERA = 0
export const HEIGHT_PROCTORING_CAMERA = 0
export const WIDTH_PROCTOR_PICTURE = 1280
export const HEIGHT_PROCTOR_PICTURE = 1024
export const PROCTORING_PHOTO_TIMER = 1000 * 5 // 5 seconds
export const PROCTORING_AUDIO_TIMER = 1000 * 60 * 2 // 2 minutes

// ONBOARDING
export const WIDTH_DEFAULT_ONBOARDING = 640
export const HEIGHT_DEFAULT_ONBOARDING = 480
export const EXAM_360_AUTOSTART_TIMER = 5

// AUTOSAVE TIMER
export const AUTOSAVE_TIMER = 30000

// EACH SECONDS TIMER
export const EACH_SECONDS = 1000

// AUDIO RECORDER
export const AUDIO_RECORDER_INPUT_DEVICEID = "AUDIO_RECORDER_INPUT_DEVICEID"
export const DEFAULT_AUDIO_RECORDING_TIMER = 3

// VIDEO RECORDER
export const VIDEO_RECORDER_INPUT_DEVICEID = "VIDEO_RECORDER_INPUT_DEVICEID"

// VIDEO CONSTRAINT
export const VIDEO_CONSTRAINTS = {
  width: 255,
  height: 200,
  facingMode: "user",
}

export const DEFAULT_EQUIPMENT_CHECK: Partial<EquipmentCheck> = {
  syncDate: "",
  webBrowser: "",
  webVersion: "",
  desktopVersion: "",
  osName: "unknown",
  microphone: false,
  sound: false,
  camera: false,
  networkDownload: -1,
  networkUpload: -1,
}
